<div *ngIf="form">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="pt-5 pb-4">
      <button
        data-test-id="send-button"
        class="btn btn-primary"
        type="submit"
        [disabled]="form.invalid || !form.value.items"
      >
        {{ 'BTN_SEND_MESSAGE_HINT' | translate }}
      </button>
    </div>
    <p class="mb-2">
      {{ 'SELECT_PEOPLE' | translate }}:
      <span *ngIf="form.status === 'INVALID' && !form.pristine" class="text-danger">
        {{ 'AT_LEAST_ONE_PERSON' | translate }}
      </span>
    </p>
    <ul class="list-group list-group-flush">
      <li class="list-group-item d-flex border-0">
        <div class="form-check align-self-center" data-test-id="wrap-checkbox-select-all">
          <input
            data-test-id="select-all-input"
            formControlName="selectAll"
            (input)="selectAll()"
            type="checkbox"
            class="form-check-input"
            id="check-all"
          />
          <label data-test-id="select-all-label" class="form-label ms-3 ps-3 me-2 pe-2" for="check-all">
            {{ 'SELECT_ALL' | translate }}
          </label>
        </div>

        <ng-container *ngIf="selectedFilter$ | async as selectedFilter">
          <app-filter-drop-down
            class="ms-3"
            [filter]="pageConfig.filter"
            [selectedFilter]="selectedFilter"
            (filterSelected)="applyFilterByCategory($event)"
          >
          </app-filter-drop-down>
        </ng-container>
      </li>
      <li
        formArrayName="items"
        *ngFor="let item of form.get('items')['controls']; index as i"
        class="list-group-item d-flex"
      >
        <div class="form-check d-flex align-items-center" [attr.data-test-id]="'wrap-checkbox-' + i">
          <input
            [attr.data-test-id]="'check-user-' + i"
            [formControlName]="i"
            [attr.id]="'checkbox-' + i"
            type="checkbox"
            class="form-check-input"
            (input)="toggleUserCheckbox(i)"
          />
          <label [attr.data-test-id]="'label-' + i" [attr.for]="'checkbox-' + i" class="d-flex form-label px-3">
            <app-user-basic [user]="users[i]" [srtIndex]="i + ''"></app-user-basic>
          </label>
        </div>
      </li>
    </ul>
  </form>
</div>
